<template>
  <div class="product-complement large-3 medium-3 small-12">
    <a
      class="product-complement__image-link"
      :href="productInfo.link">
      <img
        :alt="productInfo.title"
        class="product-complement__image"
        :src="`${productInfo.image}&w=220&auto=format`" />
    </a>
    <div class="product-complement__details">
      <a :href="productInfo.link">
        <div
          class="product-complement__title"
          v-html="productInfo.title"></div>
        <i
          class="product-complement__description"
          v-html="productInfo.usp"></i>
        <div
          class="product-price"
          :class="discountActive ? 'product-price--discount' : null">
          <span
            v-if="discountActive"
            class="product-price product-price--original">
            {{ getMyOriginalPrice() }}
          </span>
          {{ getMyPrice() }}
          <br />
          <span
            v-if="productInfo.basePrice.amount && productInfo.basePrice.brutto"
            class="product-complement__price-per-unit">
            {{ formatHelper.getPrice(productInfo.basePrice.brutto, productInfo.currency) }} / {{ productInfo.basePrice.amount }} {{ productInfo.basePrice.unit }}
          </span>
        </div>
      </a>
      <template v-if="productInfo.purchasePossible && (!limitingActive || (limitingActive && shoppingAllowed))">
        <div class="product-complement__add-to-cart">
          <span
            v-if="!loading"
            @click.prevent="addItemToCart(productInfo.matchcode)">{{ t.addToCart }}</span>
          <div
            v-if="loading"
            class="cp-round cp-spinner">
          </div>
        </div>
      </template>
      <template v-if="limitingActive && !shoppingAllowed">
        <div class="product-complement__add-to-cart">
          <a :href="productInfo.link">{{ t.goToProduct }}</a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import CustomerHelper from '../../helpers/CustomerHelper';
  import OldCartHelper from '../../helpers/OldCartHelper';
  import ProductListMixins from '../../mixins/ProductListMixins';
  import CookieHelper from '../../helpers/OldCookieHelper';
  import PriceMethods from '../../methods/PriceMethods';
  import OldFormatHelper from '../../helpers/OldFormatHelper';
  import DataLayerHelper from '../../helpers/DataLayerHelper';

  export default {
    mixins: [ProductListMixins],
    data() {
      return {
        formatHelper: OldFormatHelper,
        initialized: false,
        isPartner: false,
        loading: false,
      };
    },
    props: {
      limitingActive: {
        default: false,
        type: Boolean,
      },
      productInfo: {
        default: () => {},
        type: Object,
      },
      shoppingAllowed: {
        default: true,
        type: Boolean,
      },
      t: {
        default: () => {},
        type: Object,
      },
    },
    methods: {
      ...PriceMethods,
      async addItemToCart(matchcode) {
        this.loading = true;
        const cartId = CookieHelper.getLastUsedCartId();

        const body = { amount: 1, matchcode };

        if(cartId) {
          body.cartId = cartId;
        }

        await OldCartHelper.addItemToCart(body);

        const atcProducts = {
          id: this.productInfo.matchcode,
          name: this.productInfo.title,
          price: this.getMyPriceUnformatted(),
          quantity: 1,
        };
        DataLayerHelper.setProductInfoOnAddToCartToGtm(atcProducts);
        this.loading = false;
      },
      async checkPartnerStatus() {
        this.isPartner = await CustomerHelper.getPartnerStatus();
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../assets/styles/rin-product';

  .product-complement {
    align-items: flex-start;
    display: flex !important; // slick slider sets inline-block
    flex-direction: row;
    min-height: 225px;
    padding: 0 16px;
    width: 290px !important; // slick slider sets 100%

    &:hover {
      .product-complement__add-to-cart { display: inline; }
      .product-complement__description { display: block; }
      .product-complement__title { display: none; }
    }

    &__add-to-cart {
      border-bottom: 1px solid @colorBlack;
      color: @colorBlack;
      cursor: pointer;
      display: none;
      font-size: .55rem;
      letter-spacing: 2.5px;
      text-transform: uppercase;
    }

    &__description {
      display: none;
    }

    &__image {
      height: auto;
      width: 110px;
    }

    &__image-link {
      flex: 0 0 auto;
    }

    &__price-per-unit {
      color: @colorBlack;
      font-family: @fontRegular;
      font-size: 10px;
      letter-spacing: .5px;
    }

    &__title {
      font-family: Eina01-SemiBold, sans-serif;
    }
  }

  .product-complement-wrapper .product-complement-image .product-complement-details .add-to-cart .cp-spinner {
    display: none;
    margin: 0 auto;
  }

  .product-complement-wrapper .product-complement-image:hover .product-complement-details .add-to-cart .cp-spinner { display: block; }
</style>
